export default __webpack_public_path__ + "static/media/Vector-1.5a734b51.svg";